import { IAllocationDimension } from "helpers/allocation-dimension";
import { buildColumnExpression } from "helpers/utils/build-column-expression";
import { Validator } from "helpers/validator";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";

export class AttributeIsReadonlyRule extends Validator<IAttributeData[], IAttributeDataError> {
    noAttributesColumns: string[];
    allocationDimension: IAllocationDimension;

    constructor(noAttributesColumns: string[], allocationDimension: IAllocationDimension) {
        super();
        this.noAttributesColumns = noAttributesColumns;
        this.allocationDimension = allocationDimension;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let readOnlyAttributes = [];
        if (!errors[RuleType.AttributeIsReadonlyRule] && this.allocationDimension) {
            const headers = Object.keys(model[0] || {});
            readOnlyAttributes = headers.reduce((acc, column) => {
                const expression = buildColumnExpression(column);
                if (
                    !this.noAttributesColumns.some((field) => expression.test(field)) &&
                    this.allocationDimension.attributes.keys.some(
                        (attribute) => attribute.display?.read_only && expression.test(attribute.display_name)
                    )
                ) {
                    acc.push(column);
                }

                return acc;
            }, []);
        }

        const validationErrors = readOnlyAttributes.length
            ? {
                  ...errors,
                  [RuleType.AttributeIsReadonlyRule]: readOnlyAttributes,
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
